import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Item } from 'models/ItemModel';


const ItemList: React.FC = () => {
  const width = { date: 10, mode:10, product: 15, skucode:10, status:15, order: 15, location: 10, comment: 15 }
  const [formId, formName] = [Code.Form.Id.ITEM, Code.Form.Name.ITEM];
  const {keyId, loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [itemData, setItemData] = useState<Item[]>([]); 
  const [selectedItem, setselectedItem] = useState<Item | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, rows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Item.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Item.Date, 
        Name.Item.SKU, 
        Name.Form.Id, 
        Name.Common.CommonId, 
        Name.Product.Id, 
        Name.Product.Name, 
        Name.Item.ItemStatusName, 
        Name.Item.OrderStatusName, 
        Name.Item.Comment, 
        Name.Location.Name, 
      ]),
      inventory_id: keyId,
    });
    await API.Data.List<Item>(url, setItemData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <style>{'.list-data{top:50px;}'}</style>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, itemData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Date, width.date], 
                [Title.Mode, width.mode], 
                [Title.Product, width.product],
                [Title.Skucode, width.skucode],
                [Title.State, width.status],
                [Title.Type, width.order],
                [Title.Location, width.location],
                [Title.Comment, width.comment]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(itemData) && (
              <Control.Grid.Row>
                {itemData.map((itemData) => { return (
                  <Control.Grid.Data<Item> key={itemData.item_id} itemKey={itemData.item_key} data={itemData} setMenuPosition={setMenuPosition} setSelectedData={setselectedItem} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={itemData.item_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Get.FormLink(itemData.form_id,itemData.common_id, itemData.item_id)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Items values={[
                      [Utility.Format.DateOnly(itemData.item_date), width.date], 
                      [Utility.Get.FormName(itemData.form_id), width.mode], 
                      [itemData.product_name, width.product],
                      [itemData.item_skucode, width.skucode],
                      [itemData.item_status_name, width.status],
                      [itemData.order_status_name, width.order],
                      ["-", width.location],
                      [itemData.item_comment, width.comment]
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={itemData.item_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={itemData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedItem?.item_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedItem?.item_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ItemList;